import cx from 'classnames';
import React, { Component } from 'react';

import styles from './ControlPanelWrapper.scss';

class ControlPanelWrapper extends Component {
  render() {
    const { children, onDone, isFlex, isTop, isBig, isHidden, hideFromTop, height, t, noScroll, onClickOutside, large } = this.props;
    const containerClasses = cx({
      [styles.container]: true,
      [styles.controlWrapperOnTop]: isTop || hideFromTop,
      [styles.shown]: !isHidden,
      [styles.big]: isBig,
      [styles.large]: large
    });
    const controlWrapperClasses = cx({
      [styles.controlWrapper]: true,
      [styles.controlWrapperFlex]: isFlex,
      [styles.noScroll]: noScroll,
      [styles.large]: large
    });

    const containerStyle = {};
    if (height) {
      containerStyle.height = height;
    }
    return [
      <div key="content" className={containerClasses} style={containerStyle}>
        <div className={controlWrapperClasses}>{children}</div>
        <div className={styles.actionPanel}>
          <button className={styles.doneButton} onClick={onDone}>
            {t('EDITOR_MOBILE_DONE')}
          </button>
        </div>
      </div>,
      <div
        key="background"
        onClick={onClickOutside}
        className={cx(styles.background, {
          [styles.backgroundVisible]: !isHidden
        })}
        style={{
          position: 'fixed',
          height: '100vh',
          width: '100vw',
          left: 0,
          top: 0,
          display: isHidden ? 'none' : ''
        }}
      />
    ];
  }
}

export default ControlPanelWrapper;
